import { WeatherStationLastDaysByCityModel } from '../models/weather-station-last-days-by-city';

export class WeatherStationLastDaysByCityAdapter {
  static fromApi(response: any): WeatherStationLastDaysByCityModel {
    const data = response.data || response;

    return {
      id: data.id,
      identification: data.identification,
      hashId: data.hashId,
      temp: data.temp,
      tempMin: data.tempMin,
      tempMax: data.tempMax,
      humiMin: data.humiMin,
      humiMax: data.humiMax,
      wind: data.wind,
      windBurst: data.windBurst,
      rainAccum: data.rainAccum,
      humidity: data.humidity,
      radiation: data.radiation,
      evapo: data.evapo,
      pressure: data.pressure,
      generationDate: data.generationDate,
      creationDate: data.creationDate,
      updateDate: data.updateDate,
      userNameCreate: data.userNameCreate,
      userNameUpdate: data.userNameUpdate,
      stationId: data.stationId,
      dataSource: data.dataSource,
    };
  }

  // Método para mapear um array de dados
  static fromApiArray(response: any): WeatherStationLastDaysByCityModel[] {
    // A API retorna {data: [...], message, status}
    const dataArray = response.data || response;

    if (Array.isArray(dataArray)) {
      return dataArray.map((item) => this.fromApi({ data: item }));
    }

    return [];
  }
}
